export const channelsConfigNames = [
    'adeciaControlChannels',
    'alfatronControlChannels',
    'alfatronDsp88ControlChannels',
    'alfatronVideoSwitcherControlChannels',
    'ashlyMxaDspControlChannels',
    'ashlyNeDspControlChannels',
    'atdm0604ControlChannels',
    'avProSwitcherControlChannels',
    'biampVideoBarControlChannels',
    'controlSpaceControlChannels',
    'convergeProControlChannels',
    'convergePro2ControlChannels',
    'dm8000ControlChannels',
    'eclerVidaControlChannels',
    'extronVolumeControlControlChannels',
    'lencoreControlChannels',
    'netvioControlChannels',
    'nurevaControlChannels',
    'p300ControlChannels',
    'powersoftUnicaControlChannels',
    'qSysControlChannels',
    'radiusControlChannels',
    'solaroControlChannels',
    'soundStructureControlChannels',
    'stewartAudioControlChannels',
    'tesiraControlChannels',
    'userDriverControlChannels',
    'yamahaMtxControlChannels',
    'zoomControlChannels',
];
export const dspDetectedFilterNames = [
    'amplifier',
    'assistiveListeningMute',
    'assistiveListeningMuteStatus',
    'assistiveListeningVolume',
    'audioInputMute',
    'audioInputMuteStatus',
    'audioInputVolume',
    'mics',
    'micsMuteStatus',
    'overflowRoomMute',
    'overflowRoomMuteStatus',
    'overflowRoomVolume',
    'preset',
    'receiveGain',
    'soundReinforcementMute',
    'soundReinforcementMuteStatus',
    'soundReinforcementVolume',
    'telephony',
];
export function isDspDetectedFilterName(value) {
    return dspDetectedFilterNames.some(n => n === value);
}
export const dspManualChannelNames = [
    'amplifier',
    'assistiveListening',
    'audioInputSources',
    'mics',
    'overflowRooms',
    'soundReinforcement',
    'telephony',
];
export function isVideoInputInternal(videoInput) {
    return (videoInput.icon !== undefined &&
        videoInput.name !== undefined);
}
